<template lang="pug">
section.main(:class="collapsed ? 'wide' : 'narrow'")
  Header(ref="header")
  Menu
  section.page.peoples(ref="page",v-if="$auth.isAuthenticated && currentUser")
    h1.title
      i.icon.fas.fa-users
      span {{ page.title }}

      b-button.position-absolute.ml-2(v-if="currentUser && currentUser.acl && currentUser.acl.peoples && currentUser.acl.peoples.post && currentUser.role !== 'staff'",style="right:1.5rem",size="sm",variant="primary",@click="handleLink(`/${$route.params.directory}/people/`); mode = 'add'",:disabled="currentUser && currentUser.role === 'staff'")
        i.fas.fa-plus
        span.ml-2.mr-1 候補者の追加

    section.body(ref="body")
      .lock(ref="lock",v-if="lock",@click="unlock()")
      b-navbar
        //-b-navbar-nav.feature
          b-dropdown(size="sm",variant="outline-secondary")
            template(v-slot:button-content)
              i.fas.fa-ellipsis-v
        b-navbar-nav
          b-button(size="sm",variant="link",v-if="!toggleSearch",@click="toggleSearch=true")
            i.fas.fa-search
          b-nav-form.search(@submit.prevent)
            b-input-group(size="sm",v-if="toggleSearch")
              b-form-input(size="sm",v-model="filters.keyword",placeholder="氏名・部署・役職の一部で検索")
              b-input-group-append
                b-button(size="sm",@click="toggleSearch=false")
                  i.fas.fa-times
          b-nav-form.filters.ml-3(inline)
            b-input-group(size="sm")
              b-form-select(size="sm",v-model="filters.job",:options="options.job")
            b-input-group.ml-2(size="sm")
              b-form-select(size="sm",v-model="filters.category",:options="options.category")
            b-input-group.ml-2(size="sm",v-if="filters.category")
              b-form-select(size="sm",v-model="filters.route",:options="options.route")
            b-input-group.ml-2(size="sm")
              b-form-select(size="sm",v-model="filters.tag")
                b-form-select-option(v-for="(tag, index) in options.tag",:key="index",:value="tag.value") {{ tag.text }} {{ tag.count > 0 ? `(${tag.count})` : '' }}
            b-form-checkbox.ml-3(size="sm",switch,v-model="filters.incSelector")
              .align-items-center
                small 自分が選考官

      .w-100
        b-tabs(ref="status",v-model="filters.status",pills,card,vertical,nav-wrapper-class="counts")
          b-tab(:title="`選考中 (${counts.under ? counts.under : '0'})`",title-link-class="under",v-show="currentUser.role !== 'agent'")
          b-tab(title-link-class="null",v-show="currentUser.role !== 'agent'")
            template(v-slot:title)
              .d-flex.flex-column.linebreaking
                span 書類選考
                span 設定待ち({{ `${counts.null ? counts.null : '0'}` }})
          b-tab(title-link-class="undecided",v-show="currentUser.role !== 'agent'")
            template(v-slot:title)
              .d-flex.flex-column.linebreaking
                span 次回選考
                span 設定待ち({{ `${counts.undecided ? counts.undecided : '0'}` }})
          b-tab(title-link-class="scheduled",v-show="currentUser.role !== 'agent'")
            template(v-slot:title)
              .d-flex.flex-column.linebreaking
                span 次回選考
                span 設定済み({{ `${counts.scheduled ? counts.scheduled : '0'}` }})
          b-tab(title-link-class="unevaluated",v-show="currentUser.role !== 'agent'")
            template(v-slot:title)
              .d-flex.flex-column.linebreaking
                span 選考結果
                span 入力待ち({{ `${counts.unevaluated ? counts.unevaluated : '0'}` }})
          b-tab(:title="`内定 (${counts.offer ? counts.offer : '0'})`",title-link-class="offer",v-show="currentUser.role !== 'agent'")
          b-tab(:title="`入社決定 (${counts.employ ? counts.employ : '0'})`",title-link-class="employ",v-show="currentUser.role !== 'agent'")
          b-tab(:title="`保留 (${counts.keep ? counts.keep : '0'})`",title-link-class="keep",v-show="currentUser.role !== 'agent'")
          b-tab(:title="`選考終了 (${counts.failure ? counts.failure : '0'})`",title-link-class="offer",v-show="currentUser.role !== 'agent'")
          b-tab(:title="`すべて (${allCount ? allCount : '0'})`")

        section.list
          b-table.data(ref="table",responsive,sticky-header,no-local-sorting,:items="data",:fields="fields",:sort-by="sort",:sort-desc="desc",@sort-changed="sortChanged",select-mode="single",selectable,@row-selected="rowSelected")
            template(v-slot:cell(tags)="row")
              b-badge.mr-1(v-for="(tag, index) in row.item.tags",:key="index",label="",variant="light",pill) {{ tag }}

          b-navbar.bottom
            b-navbar-nav
              b-button.mr-2(size="sm",variant="link",@click="loadData")
                i.fas.fa-sync-alt
              b-nav-text.ml-2.text-muted.small {{ (currentPage - 1) * perPage + 1 }} -
                template(v-if="filteredCount === allCount")
                  span.ml-1 {{ perPage > allCount ? allCount : perPage }}
                  span.ml-2 /
                  span.ml-2 {{ allCount }} 件
                template(v-else)
                  span.ml-1 {{ perPage > filteredCount ? filteredCount : perPage }}
                  span.ml-2 /
                  span.ml-2 {{ allCount }} 件中、該当 {{ filteredCount }} 件
            b-nav-form.form-inline.ml-auto.mr-3
              label.small.mr-2 表示件数
              b-form-select(size="sm",v-model="perPage",:options="optionsPerPage")
            b-navbar-nav
              b-pagination.py-0.my-0.ml-auto.mr-2.align-items-center(v-if="filteredCount",v-model="currentPage",:per-page="perPage",:total-rows="filteredCount")

  b-modal#modal-preview(hide-header,size="xl",@shown="shownPeopleFile",@hidden="hiddenPeopleFile")
    template(v-slot:default)
      .previewWrapper(v-if="previewFile")
        template(v-if="previewFile && (previewFile.extension === 'png' || previewFile.extension === 'jpeg' || previewFile.extension === 'gif' || previewFile.extension === 'bmp' || previewFile.extension === 'svg')")
          img.img-fluid.mx-auto#previewPeopleFile
        template(v-if="previewFile && previewFile.extension === 'pdf'")
          #previewPeopleFile.pdf
        template(v-if="previewFile && previewFile.extension === 'markdown'")
          #previewPeopleFile.markdown
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(variant="primary",@click="downloadPeopleFile") ダウンロード
      b-button(variant="secondary",@click="$bvModal.hide('modal-preview')") 閉じる
</template>

<script>
import { cloneDeep, debounce } from 'lodash'

import QueryHash from 'query-hash'

import { getData } from '../utils/api'

import { clone, optionsCategory } from '../utils/libs'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.locale('ja')
dayjs.extend(localizedFormat)

const page = {
  id: 'peoples',
  title: '候補者一覧'
}

export default {
  name: page.id,
  // props: ['mode'],
  data () {
    return {
      mask: false,
      lock: false,
      page: page,
      collapsed: true,
      currentUser: null,
      mode: null,
      prepared: false,
      data: [],
      params: {},
      filters: {
        job: null,
        category: null,
        route: null,
        tag: null,
        status: 0,
        incSelector: false
      },
      options: {
        job: [],
        category: [],
        route: [],
        tag: []
      },

      previewPerson: null,
      previewFile: null,

      allCount: null,
      filteredCount: null,
      counts: {},
      currentPage: null,
      perPage: null,
      sort: 'appliedAt',
      desc: true,
      defaultOrder: '-appliedAt',
      toggleSearch: false,
      fields: [
        /*
        {
          key: 'selected',
          label: 'selected',
          class: 'checkbox'
        },
        */
        {
          key: 'name',
          label: '氏名',
          sortable: true,
          formatter: (val, key, datum) => {
            return `${datum.lastName} ${datum.firstName}`
          }
        }, {
          key: 'jobId',
          label: 'ポジション',
          sortable: true,
          formatter: (val, key, datum) => {
            return datum.Job && datum.Job.name ? datum.Job.name : ''
          }
        }, {
          key: 'routeId',
          label: 'ルート',
          sortable: true,
          formatter: (val, key, datum) => {
            return datum.Route && datum.Route.name ? datum.Route.name : ''
          }
        }, {
          key: 'tags',
          label: 'タグ',
          sortable: false
        }, {
          key: 'postedAt',
          label: '作成日時',
          sortable: true,
          formatter: (val, key, datum) => {
            return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : '-'
          }
        }
      ],
      optionsPerPage: [
        { value: 10, text: '10件' },
        { value: 20, text: '20件' },
        { value: 50, text: '50件' },
        { value: 100, text: '100件' }
      ]
    }
  },
  watch: {
    currentPage (newVal, oldVal) {
      if (oldVal && newVal && oldVal !== newVal) {
        this.loadData()
      }
    },
    perPage (newVal, oldVal) {
      if (oldVal && newVal && oldVal !== newVal) {
        this.loadData()
      }
    },
    toggleSearch (val) {
      if (!val) {
        this.clearKeyword()
      }
    },
    'filters.keyword': debounce(function () {
      this.loadData()
    }, 1000),
    'filters.status' (val) {
      this.loadData()
    },
    'filters.job' (val) {
      this.loadData()
    },
    async 'filters.category' (val) {
      if (val) {
        const category = this.$data.options.category.find((obj) => {
          return obj.value === val
        })

        if (this.$route.query.fr) {
          this.filters.route = this.$route.query.fr
        } else {
          this.filters.route = null
        }

        this.options.route = [{
          value: null, text: `すべて（${category.text}）の採用ルート`
        }]

        let query = new QueryHash()

        let filters = [{ category: category.value }]
        query.add('filter', JSON.stringify({ $and: filters }))

        query.add('fields', '_id,category,name')
        query.add('sort', 'postedAt')
        query.add('limit', -1)

        await getData(`/routes?${query.toQueryString()}`).then((data) => {
          for (let datum of data) {
            this.options.route.push({
              value: datum._id, text: datum.name
            })
          }
        }).catch((err) => {
          console.log(err)
        })

        if (this.options.route.length === 1) {
          this.filters.route = null
        }

        if (this.filters.route) {
          const isFindRoute = this.options.route.find((elm) => {
            return elm && elm.value && elm.value === this.filters.route
          })
          if (!isFindRoute) {
            this.filters.route = null
          }
        }
      } else {
        this.options.route = []
      }

      this.loadData()
    },
    'filters.route' (val) {
      this.loadData()
    },
    'filters.tag' (val) {
      this.loadData()
    },
    'filters.incSelector' (val) {
      this.loadData()
    }
  },
  mounted () {
    if (this.$route.query.pn) {
      this.currentPage = Number(this.$route.query.pn)
    } else {
      this.currentPage = 1
    }
    if (this.$route.query.pp) {
      this.perPage = Number(this.$route.query.pp)
    } else {
      this.perPage = 10
    }

    if (this.$route.query.order) {
      if (this.$route.query.order.substring(0, 1) === '-') {
        this.desc = true
        this.sort = this.$route.query.order.substring(1)
      } else {
        this.desc = false
        this.sort = this.$route.query.order
      }
    }
  },
  methods: {
    unlock () {
    },
    selectPeopleFile (file, people) {
      if (file.extension === 'png' || file.extension === 'jpeg' || file.extension === 'gif' || file.extension === 'bmp' || file.extension === 'svg' || file.extension === 'pdf' || file.extension === 'markdown') {
        this.previewPerson = people
        this.previewFile = file
        this.$bvModal.show('modal-preview')
      } else {
        this.download(`/peoples/${people._id}/files/${file._id}.${file.extension}`, `${file.filename}`)
      }
    },
    shownPeopleFile () {
      this.preview(`/peoples/${this.previewPerson._id}/files/${this.previewFile._id}.${this.previewFile.extension}`, `${this.previewFile.filename}`, 'previewPeopleFile')
    },
    hiddenPeopleFile () {
      this.previewPerson = null
      this.previewFile = null
    },
    downloadPeopleFile () {
      this.download(`/peoples/${this.previewPerson._id}/files/${this.previewFile._id}.${this.previewFile.extension}`, `${this.previewFile.filename}`)
    },
    async prepareData () {
      this.mask = true

      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.prepareData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      // this.filters.job = null
      this.options.job = [{
        value: null, text: 'すべてのポジション'
      }]

      await getData(`/jobs?fields=_id,name&sort=occupation,position&limit=-1`).then((data) => {
        for (let datum of data) {
          this.options.job.push({
            value: datum._id, text: datum.name
          })
        }
      }).catch((err) => {
        console.log(err)
      })

      if (this.options.job.length === 1) {
        this.filters.job = null
      }

      // this.filters.route = null

      this.options.category = optionsCategory()
      this.options.category.unshift({
        value: null, text: 'すべての採用種別' //, disabled: true
      })

      this.options.route = []

      this.options.tag = [{
        value: null, text: 'すべてのタグ'
      }]

      await getData(`/tags?filter={count:{$gt:0}}&fields=_id,text,count&sort=count&limit=-1`).then((data) => {
        for (let datum of data) {
          this.options.tag.push({
            value: datum.text, text: datum.text, count: datum.count
          })
        }
      }).catch((err) => {
        console.log(err)
      })

      if (this.options.tag.length === 1) {
        this.filters.tag = null
      }

      if (this.$route.query.fk) {
        this.filters.keyword = this.$route.query.fk
        this.toggleSearch = true
      }

      if (this.$route.query.fj) {
        this.filters.job = this.$route.query.fj

        const isFindJob = this.options.job.find((elm) => {
          return elm && elm.value && elm.value === this.filters.job
        })
        if (!isFindJob) {
          this.filters.job = null
        }
      }

      if (this.$route.query.fc) {
        this.filters.category = this.$route.query.fc
      }
      if (this.$route.query.fr) {
        this.filters.route = this.$route.query.fr
      }
      if (this.$route.query.ft) {
        this.filters.tag = this.$route.query.ft

        const isFindTag = this.options.tag.find((elm) => {
          return elm && elm.value && elm.value === this.filters.tag
        })
        if (!isFindTag) {
          this.filters.tag = null
        }
      }

      if (this.$route.query.fs) {
        this.filters.status = this.$route.query.fs
      }

      if (this.$route.query.fis) {
        this.filters.incSelector = Boolean(this.$route.query.fis)
      }

      this.prepared = true

      this.loadData()

      this.mask = false
    },
    sortChanged (obj) {
      this.sort = obj.sortBy
      this.desc = obj.sortDesc
      this.loadData()
    },
    orderChanged () {
      this.sortChanged()
    },
    async loadData () {
      if (!this.prepared) { return }

      this.mask = true

      this.params = {}

      let filters = []
      if (this.filters.keyword) {
        const keywords = this.filters.keyword.split(/\s|\u3000/)
        const filterKeywords = []

        for (let keyword of keywords) {
          if (keyword !== '') {
            filterKeywords.push({ $or: [{
              name: `RegExp:('${keyword}')`
            }, {
              kana: `RegExp:('${keyword}')`
            }] })
          }
        }
        if (filterKeywords.length > 0) {
          filters.push({ $and: filterKeywords })
        }

        this.params.fk = this.filters.keyword
      }
      if (this.filters.job) {
        filters.push({ jobId: `ObjectId:('${this.filters.job}')` })

        this.params.fj = this.filters.job
      }
      if (this.filters.category) {
        if (this.filters.route) {
          filters.push({ routeId: `ObjectId:('${this.filters.route}')` })

          this.params.fr = this.filters.route
        } else {
          let routes = []
          this.$data.options.route.forEach((obj) => {
            if (obj && obj.value) {
              routes.push(`ObjectId:('${obj.value}')`)
            }
          })
          if (routes.length > 0) {
            filters.push({ routeId: { $in: routes } })
          } else {
            filters.push({ routeId: null })
          }
        }

        this.params.fc = this.filters.category
      }
      if (this.filters.tag) {
        filters.push({ tags: { $in: [this.filters.tag] } })

        this.params.ft = this.filters.tag
      }

      if (this.filters.incSelector) {
        this.params.fis = this.filters.incSelector
      }

      let indFilters
      let indQuery

      indFilters = clone(filters)

      indQuery = new QueryHash()
      if (indFilters.length > 0) {
        indQuery.add('filter', JSON.stringify({ $and: indFilters }))
      }
      if (this.filters.incSelector) { indQuery.add('incSelector', 1) }

      this.allCount = 0
      await getData(`/peoples/count?${indQuery.toQueryString()}`).then((count) => {
        this.allCount = count
      })

      indFilters = clone(filters)
      indFilters.push({
        $and: [
          { kept: { $ne: true } },
          {
            $or: [
              { status: null }, { status: 'unevaluated' }, { status: 'undecided' }
            ]
          }
        ]
      })

      indQuery = new QueryHash()
      indQuery.add('filter', JSON.stringify({ $and: indFilters }))
      if (this.filters.incSelector) { indQuery.add('incSelector', 1) }

      await getData(`/peoples/count?${indQuery.toQueryString()}`).then((count) => {
        this.$set(this.$data.counts, 'under', count)
      })

      indFilters = clone(filters)
      indFilters.push({
        $and: [
          { kept: { $ne: true } },
          { $or: [{ status: null }, { status: '' }] }
        ]
      })

      indQuery = new QueryHash()
      indQuery.add('filter', JSON.stringify({ $and: indFilters }))
      if (this.filters.incSelector) { indQuery.add('incSelector', 1) }

      await getData(`/peoples/count?${indQuery.toQueryString()}`).then((count) => {
        this.$set(this.$data.counts, 'null', count)
      })

      indFilters = clone(filters)
      indFilters.push({
        $and: [
          { kept: { $ne: true } },
          { status: 'undecided' }
        ]
      })

      indQuery = new QueryHash()
      indQuery.add('filter', JSON.stringify({ $and: indFilters }))
      if (this.filters.incSelector) { indQuery.add('incSelector', 1) }

      await getData(`/peoples/count?${indQuery.toQueryString()}`).then((count) => {
        this.$set(this.$data.counts, 'undecided', count)
      })

      indFilters = clone(filters)
      indFilters.push({
        $and: [
          { kept: { $ne: true } },
          { status: 'unevaluated', nextScreeningDate: { $gt: dayjs().format('YYYY-MM-DD') } }
        ]
      })

      indQuery = new QueryHash()
      indQuery.add('filter', JSON.stringify({ $and: indFilters }))
      if (this.filters.incSelector) { indQuery.add('incSelector', 1) }

      await getData(`/peoples/count?${indQuery.toQueryString()}`).then((count) => {
        this.$set(this.$data.counts, 'scheduled', count)
      })

      indFilters = clone(filters)
      indFilters.push({
        $and: [
          { kept: { $ne: true } },
          { status: 'unevaluated', nextScreeningDate: { $lte: dayjs().format('YYYY-MM-DD') } }
        ]
      })

      indQuery = new QueryHash()
      indQuery.add('filter', JSON.stringify({ $and: indFilters }))
      if (this.filters.incSelector) { indQuery.add('incSelector', 1) }

      await getData(`/peoples/count?${indQuery.toQueryString()}`).then((count) => {
        this.$set(this.$data.counts, 'unevaluated', count)
      })

      indFilters = clone(filters)
      indFilters.push({ status: 'offer' })
      indFilters.push({ employed: false })

      indQuery = new QueryHash()
      indQuery.add('filter', JSON.stringify({ $and: indFilters }))
      if (this.filters.incSelector) { indQuery.add('incSelector', 1) }

      await getData(`/peoples/count?${indQuery.toQueryString()}`).then((count) => {
        this.$set(this.$data.counts, 'offer', count)
      })

      indFilters = clone(filters)
      indFilters.push({ status: 'offer' })
      indFilters.push({ employed: true })

      indQuery = new QueryHash()
      indQuery.add('filter', JSON.stringify({ $and: indFilters }))
      if (this.filters.incSelector) { indQuery.add('incSelector', 1) }

      await getData(`/peoples/count?${indQuery.toQueryString()}`).then((count) => {
        this.$set(this.$data.counts, 'employ', count)
      })

      indFilters = clone(filters)
      indFilters.push({ kept: true })

      indQuery = new QueryHash()
      indQuery.add('filter', JSON.stringify({ $and: indFilters }))
      if (this.filters.incSelector) { indQuery.add('incSelector', 1) }

      await getData(`/peoples/count?${indQuery.toQueryString()}`).then((count) => {
        this.$set(this.$data.counts, 'keep', count)
      })

      indFilters = clone(filters)
      indFilters.push({ status: 'failure' })

      indQuery = new QueryHash()
      indQuery.add('filter', JSON.stringify({ $and: indFilters }))
      if (this.filters.incSelector) { indQuery.add('incSelector', 1) }

      await getData(`/peoples/count?${indQuery.toQueryString()}`).then((count) => {
        this.$set(this.$data.counts, 'failure', count)
      })

      let countQuery = new QueryHash()
      if (filters.length > 0) {
        countQuery.add('filter', JSON.stringify({ $and: filters }))
      }
      if (this.filters.incSelector) { countQuery.add('incSelector', 1) }
      await getData(`/peoples/count/?${countQuery.toQueryString()}`).then((count) => {
        this.allCount = count
        this.filteredCount = count
      })

      if (this.filters.status === 0) {
        filters.push({ $and: [{ kept: { $ne: true } }, { $or: [{ status: null }, { status: 'unevaluated' }, { status: 'undecided' }] }] })
      } else if (this.filters.status === 1) {
        filters.push({ $and: [{ kept: { $ne: true } }, { $or: [{ status: null }, { status: '' }] }] })
      } else if (this.filters.status === 2) {
        filters.push({ $and: [{ kept: { $ne: true } }, { status: 'undecided' }] })
      } else if (this.filters.status === 3) {
        filters.push({ $and: [{ kept: { $ne: true } }, { status: 'unevaluated', nextScreeningDate: { $gt: dayjs().format('YYYY-MM-DD') } }] })
      } else if (this.filters.status === 4) {
        filters.push({ $and: [{ kept: { $ne: true } }, { status: 'unevaluated', nextScreeningDate: { $lte: dayjs().format('YYYY-MM-DD') } }] })
      } else if (this.filters.status === 5) {
        filters.push({ status: 'offer', employed: false })
      } else if (this.filters.status === 6) {
        filters.push({ status: 'offer', employed: true })
      } else if (this.filters.status === 7) {
        filters.push({ kept: true })
      } else if (this.filters.status === 8) {
        filters.push({ status: 'failure' })
      }

      if (this.filters.status > 0) {
        this.params.fs = this.filters.status
      }

      countQuery = new QueryHash()
      if (filters.length > 0) {
        countQuery.add('filter', JSON.stringify({ $and: filters }))
      }
      if (this.filters.incSelector) { countQuery.add('incSelector', 1) }
      await getData(`/peoples/count/?${countQuery.toQueryString()}`).then((count) => {
        this.filteredCount = count
      })

      if (this.currentPage !== 1) {
        this.params.pn = this.currentPage
      }
      if (this.perPage !== 10) {
        this.params.pp = this.perPage
      }

      let offset = (this.currentPage - 1) * this.perPage

      let order = null
      if (this.desc) {
        order = `-${this.sort}`
      } else {
        order = this.sort
      }

      if (order !== this.defaultOrder) {
        this.params.order = order
      }

      let query = new QueryHash()

      query.add('sort', order)
      query.add('limit', this.perPage)
      if (offset !== 0) {
        query.add('skip', offset)
      }

      // this.mode = 'list'

      if (filters.length > 0) {
        query.add('filter', JSON.stringify({ $and: filters }))
      }
      if (this.filters.incSelector) { query.add('incSelector', 1) }

      this.data = []
      await getData(`/peoples?${query.toQueryString()}`).then(async (data) => {
        if (data && data.length > 0) {
          this.data = cloneDeep(data)
        }
      }).catch((err) => {
        console.log(err)
      })

      this.$router.replace({ name: 'List Peoples', query: this.params }).catch(() => {})

      this.$refs.header.checkCondition()

      this.$refs.table.clearSelected()

      this.mask = false
    },
    clearKeyword () {
      this.filters.keyword = null
    },
    rowSelected (data) {
      let params = cloneDeep(this.$route.query)
      if (data && data.length > 0) {
        params.id = data[0]._id

        this.handleLink(`/${this.$route.params.directory}/people/${data[0]._id}`)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.page
  .body
    z-index 100
    position responsive
    .tabs
      height calc(100vh - 3.75rem - 5.5rem - 3.375rem)
      background-color rgba(0, 0, 0, 0.03)
      width 12rem
      >>> .tab-content.col
        display none
      >>> .nav
        width 12rem
        white-space nowrap
        // display block !important
        flex-wrap nowrap
        max-width 100%
        overflow-x scroll
        overflow-y hidden
        -webkit-overflow-scrolling touch
        // -ms-overflow-style none

        .nav-item
          display inline-block
          .nav-link
            height calc(3.375rem - 1px)
            line-height 2.375rem
            border-radius 0
            padding 0.5rem 2rem

            background-color #fafafa
            color #444
            border-right 1px solid #e6e8f1

            &.active
              background-color #fff
              color #222
              font-weight 600

            .linebreaking
              line-height 1.125rem

    .data.table-responsive
      top 3.4375rem
      overflow scroll
      min-height calc(100vh - 3.75rem - 5.5rem - 3.375rem - 3.4375rem)
      // height calc(100vh - 3.75rem - 5.5rem - 3.375rem)
      left 12rem

      >>> table
        thead
          th
            border-bottom 1px solid #e6e8f1
        tbody
          tr:first-child
            td
              border-top 0 none
        tr.b-table-row-selected
          td
            background-color #fed
    .navbar.bottom
      position absolute
      left 12rem
      right 0
      bottom 0
.narrow .page
  .body
    .data.table-responsive
      position absolute
      width calc(100% - 12rem)
    .navbar.bottom
      width calc(100% - 12rem)
.page
  .body
    .data.table-responsive
      position absolute
      width calc(100% - 12rem)
    .navbar.bottom
      width calc(100% - 12rem)
</style>
